export const CUSTOMER_ORDER_ID_COLUMN = 'customer_order_id'

/**
 * @param {string | null | undefined} value
 */
export const hasCustomerOrderIdValue = (value) =>
  typeof value === 'string' ? value.trim() !== '' : Boolean(value)

/**
 * Appends `customer_order_id` to a Supabase/PostgREST select clause.
 *
 * @param {string} selectClause
 */
export function buildShipmentSelectFields(selectClause) {
  if (!selectClause) {
    return selectClause
  }

  if (selectClause.includes('customer_order_id')) {
    return selectClause
  }

  return selectClause.replace(/(\border_number,\s*)/, '$1\n                    customer_order_id,')
}

/**
 * @param {string | null | undefined} value
 */
export function normalizeCustomerOrderIdForPayload(value) {
  return value?.trim?.() ? value.trim() : null
}
